import React from 'react'
import './ProjectShowcase.css'

export default class ProjectShowcase extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      isLoaded: false
    }
  }

  componentDidMount() {
    this.setState({ isLoaded: true })
  }
  
  renderProjectCards () {
    const { max, data, ui } = this.props.widget
    return (
      data.map((element, idx) => {
        if (idx >= max) {
          return null
        }

        const { img, title, shortDesc } = element
        const className = `project-card ${ui && ui.showImageBorder === false ? 'no-shadow' : ''}`

        return (
          <div key={idx} className={className}>
            <img src={img} alt='alt' />
            <h3>{ title }</h3>
            <span className='short-desc'>{ shortDesc }</span>
          </div>
        )
      })
    )
  }

  render () {
    return (
      <div>
        {this.props.widget.subText && <p className="text-top-projects">{this.props.widget.subText}</p>}
        <div className='project-card-items'>
          { this.state.isLoaded && this.renderProjectCards() }
        </div>
      </div>
    )
  }
}